var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sideModal",staticClass:"side-modal p-30"},[_c('div',{staticClass:"close-side-modal",on:{"click":_vm.close}}),_c(_vm.dashSideModalComponent,{tag:"component",attrs:{"data":_vm.dashSideModalContent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }